
import billingService from '@api/routes/cart/getbillinginformation';
import shippingService from '@api/routes/cart/getshippinginformation';
// remove these to and combimed into review
import selectAddressService from '@api/routes/cart/selectoraddbillingaddress';
import selectPaymentService from '@api/routes/cart/addexistingpaymentmethod';
import AddBillingAndPaymentMethodToCart from '@api/routes/cart/AddBillingAndPaymentMethodToCart';
import uniqid from 'uniqid';
import ReactiveComponent, { computed, watch } from "@utils/reactive-component";
import parseRenderingContext from '@utils/parse-rendering-context';
import isFn from '@utils/is-function';
import AjaxLoader from '../ajax-loader/ajax-loader';
import SelectBox from '../select-box/select-box';
import CheckoutAddressForm, { DEFAULT_OPTIONS as addressFormDefaults } from './checkout-address-form-cc';
import CheckoutPaymentForm from './checkout-payment-form';
import AddressValidation, { logUpsServiceError, showSuggestions, statusCodes } from '../address-validation/address-validation';
import template from './templates/checkout-billing';
import { context as defaultContext } from './checkout-defaults';
import store from '@stores/cart/cart-store';

import AddPayment from '../add-payment';
// needs to change everwhere form cart to account
import { url as apiUrl } from '@api/routes/account/addpaymentmethod';

const CLASS_NAME_ADD_ADDRESS_DISABLED = '-disabled';
const CLASS_NAME_ADD_METHOD_DISABLED = '-disabled';
const CLASS_NAME_REVIEW_BUTTON_DISABLED = 'disabled';

const NEW_ADDRESS_OPTION_VALUE = '__checkoutBilling_newAddress__';

const DEFAULT_OPTIONS = {
    addPaymentFormClassList: '',
    classList: '',
    onCancelHandler: null,
    onCancelBillHandler: null,
    replaceOriginEl: false
};

const DEFAULT_LOADER_OPTIONS = {
    aria: false,
    className: 'd-flex align-items-center h-100',
    size: 'xs',
    visible: true
};

export default class CheckoutBilling extends ReactiveComponent {
    constructor($originEl, context, options) {
        context = { ...defaultContext, ...context };
        options = { ...DEFAULT_OPTIONS, ...options };

        super();

        const $parsed = this.parseTemplate();
        $originEl.replaceWith($parsed);

        this.$el = $parsed;

        this.$isSubscriptionsPage = $(".js-sub-section").length > 0 ;

        this.$addLabel = this.$el.find('[data-label="add"]');
        this.$addressLabel = this.$el.find('[data-label="address"]');
        this.$methodLabel = this.$el.find('[data-label="method"]');
        this.$methodWrapper = this.$el.find('[data-control="method"]');
        this.$reviewLabel = this.$el.find('[data-label="review"]');
        this.$cardHolderHeaderLabel = this.$el.find('[data-label="heading-card-name"]');
        this.$cardHolderNameLabel = this.$el.find('[data-label="cardHolderName"]');
        this.$cardHolderNameErrorLabel = this.$el.find('[data-label="cardHolderNameError"]');
        this.$cardHolderNameError = this.$el.find('[data-region="cardHolderNameError"]');
        this.$cardHolderNameCtrl = this.$el.find('[data-control="cardHolderName"]');

        this.$address = this.$el.find('[data-region="address"]');
        this.$addressForm = this.$el.find('[data-region="addressForm"]');
        this.$error = this.$el.find('[data-region="error"]');
        this.$hiddenOnForm = this.$el.find('[data-region="hidden-on-form"]');
        this.$controls = this.$el.find('[data-region="controls"]');
        this.$method = this.$el.find('[data-region="method"]');
        this.$methodForm = this.$el.find('[data-region="methodForm"]');

        this.$addAddressCtrl = this.$el.find('[data-control="addAddress"]');
        this.$addMethodCtrl = this.$el.find('[data-control="addMethod"]');
        this.$methodCancelCtrl = this.$el.find('[data-control="methodCancel"]');
        this.$reviewCtrl = this.$el.find('[data-control="review"]');

        this.$savePayment = this.$el.find("#saveNewPayment");

        this.$addressPlaceholder = $('#addPaymentContainer').find('[data-placeholder="address"]');
        this.$addressFormPlaceholder = this.$el.find('[data-placeholder="addressForm"]');
        this.$addressLoaderPlaceholder = $('#addPaymentContainer').find('[data-placeholder="addressLoader"]');
        this.$loaderPlaceholder = this.$el.find('[data-placeholder="loader"]');
        this.$methodPlaceholder = this.$el.find('[data-placeholder="method"]');
        this.$methodLoaderPlaceholder = this.$el.find('[data-placeholder="methodLoader"]');
        this.$paymentFormPlaceholder = this.$el.find('[data-placeholder="payment"]');
        this.$addressFormPlaceholder = this.$el.find('[data-placeholder="addressForm"]');
        this.$prescription = $('.cart-landing__rx[data-region="prescription"]');

        this.$promotionsnote = this.$el.find('[data-region="promotionsnote"]');

        this.addressLoader = null;
        this.addressSelector = null;
        this.loader = null;
        this.methodLoader = null;
        this.methodSelector = null;

        this.addPaymentForm = null;
        this.addPaymentFormClassList = options.addPaymentFormClassList;
        this.checkoutForm = null;

        this.id = uniqid.time('');
        this.addressId = `billingAddress_${this.id}`;
        this.methodId = `billingMethod_${this.id}`;
        this.shippingAddressId = null;
        this.shippingAddress = {};

        this.prevAddressValue = '';
        this.disableServiceUpdate = false;
        this.newAddress = {};


        this.$cancelLabel = this.$el.find('[data-label="cancel"]');
        this.$headingLabel = this.$el.find('[data-label="heading"]');
        this.$subscriptionsLabel = this.$el.find('[data-label="subscriptions"]');
        this.$submitLabel = this.$el.find('[data-label="submit"]');

        this.$amex = this.$el.find('[data-region="amex"]');
        this.$ccList = this.$el.find('[data-region="ccList"]');
        this.$discover = this.$el.find('[data-region="discover"]');
        this.$mastercard = this.$el.find('[data-region="mastercard"]');
        this.$visa = this.$el.find('[data-region="visa"]');

        //this.$openNewAddress = this.$el.find('[data-control="openAddAddress"]');
        //this.$closeAddress = this.$el.find('[data-target="cancel"]');

        this.$cancel = this.$el.find('[data-control="cancel"]');

        this.form = null;

        this.classList = options.classList;
        this.onCancelHandler = isFn(options.onCancelHandler) || null;
        this.onCancelBillHandler = isFn(options.onCancelBillHandler) || null;
        this.replaceOriginEl = options.replaceOriginEl;


        this.reactive({
            addresses: [],
            addressFormVisible: false,
            addressesLoading: true,
            addressOptions: [],
            selectedAddressValue: '',

            methods: [],
            methodsFormVisible: false,
            methodsLoading: true,
            methodOptions: [],
            selectedMethodValue: '',

            loading: true
        });

        this.loaders = [];
        this.context = context;
    }

    [computed]() {
        return {
            isNewAddress() {
                return this.selectedAddressValue === NEW_ADDRESS_OPTION_VALUE;
            },
            selectedAddressInfo() {
                if (!this.selectedAddressValue) {
                    return store.state.shippingParty;
                }

                if (this.isNewAddress) {
                    return this.newAddress;
                }

                return this.addresses.find(address => address.AddressName === this.selectedAddressValue) || null;
            }
        }
    }

    [watch]() {
        return {
            addressesLoading(loading) {
                this.addressLoader.active = loading;
            },
            methodsLoading(loading) {
                this.methodLoader.active = loading;
            },
            addressOptions(newOptions) {
                if (!newOptions || !Array.isArray(newOptions) || newOptions.length === 0) {
                    this.addressSelector.disable();
                    this.addressSelector.disableElement();
                   // console.error('invalid address options');
                }

                const options = {
                    options: newOptions
                };

                this.addressSelector.setOptions(options);
                this.addressSelector.enable();
            },
            methodsFormVisible() {
                if (this.methodsFormVisible) {
                    this.$methodForm.slideDown('fast');
                    this.$hiddenOnForm.slideUp('fast');
                    this.$addMethodCtrl.attr('aria-expanded', true);
                } else {
                    this.$methodForm.slideUp('fast');
                    this.$hiddenOnForm.slideDown('fast');
                    this.methodSelector.focus();
                    this.$addMethodCtrl.removeAttr('aria-expanded');
                }
            },
            loading(loading) {
                this.loader.active = loading;

                if (loading) {
                    this.$addAddressCtrl.addClass(CLASS_NAME_ADD_ADDRESS_DISABLED).attr('aria-disabled', true);
                    this.$addMethodCtrl.addClass(CLASS_NAME_ADD_METHOD_DISABLED).attr('aria-disabled', true);
                    this.$reviewCtrl.addClass(CLASS_NAME_REVIEW_BUTTON_DISABLED).attr('aria-disabled', true);
                } else {
                    this.$addAddressCtrl.removeClass(CLASS_NAME_ADD_ADDRESS_DISABLED).removeAttr('aria-disabled');
                    this.$addMethodCtrl.removeClass(CLASS_NAME_ADD_METHOD_DISABLED).removeAttr('aria-disabled');
                    this.$reviewCtrl.removeClass(CLASS_NAME_REVIEW_BUTTON_DISABLED).removeAttr('aria-disabled');
                }
            },
            methodOptions(newOptions) {
                if ((!newOptions || !Array.isArray(newOptions) || newOptions.length === 0) && !this.$isSubscriptionsPage) {
                    this.methodSelector.disable();
                    this.methodSelector.disableElement();
                    console.error('invalid method options');
                }

                const options = {
                    options: newOptions,
                    unselectedText: this.context.Select
                };

                this.methodSelector.setOptions(options);
                this.methodSelector.enable();
            },
            addressFormVisible() {
                if (this.addressFormVisible) {
                    if (!this.checkoutForm.rendered) {
                        this.checkoutForm.init();
                        this.checkoutForm.render();
                    }

                    this.$addressForm.slideDown('fast');
                    //this.$hiddenOnForm.slideUp('fast');
                    this.checkoutForm.focus();
                    this.$addAddressCtrl.attr('aria-expanded', true);
                } else {
                    this.$addressForm.slideUp('fast');
                    //this.$hiddenOnForm.slideDown('fast');
                    this.addressSelector.focus();
                    this.$addAddressCtrl.removeAttr('aria-expanded');
                }
            }
        }
    }

    init() {
        this.renderLabels();
        this.renderAddPaymentForm();
        //this.renderCheckoutForm();
        this.renderReviewLink();
        this.renderSelectors();
        this.renderLoaders();
        this.setupAccessibility();
        this.setupListeners();
        this.getBillingData();

        this.renderLabels2();
        this.renderAcceptedCards();
        // this.setupCancel();
        this.setupClassList();
        this.renderCheckoutForm();
        this.setEvents();
        this.render();
    }

    onCartLoaded() {
        this.loaders.forEach(loader => (loader.active = false));
        this.displayLegalDisclaimer();
    }

    renderLabels2() {
        this.$cancelLabel.html(this.context.Cancel);
        this.$headingLabel.html(this.context.AddPaymentMethod);
        this.$subscriptionsLabel.html(this.context.ActiveSubscriptions);
        this.$submitLabel.html(this.context.SavePayment);
        this.$cardHolderHeaderLabel.html(this.context.CardHolderInfo);
        this.$cardHolderNameLabel.html(this.context.CardHolderInputLabel);
        this.$cardHolderNameErrorLabel.html(this.context.CardHolderInputError);
        this.$cardHolderNameCtrl.attr('placeholder', this.context.CardHolderInputLabel);
    }

    getData() {
        return new Promise((resolve) => {
            Promise
                .all([billingService.get(), shippingService.get()])
                .then(([billingResponse, shippingResponse]) => {
                    resolve({
                        ...billingResponse,
                        shippingAddressId: shippingResponse?.data?.AddressId || null
                    });
                });
        });;
    }

    async getShippingAddressId() {
        const { data } = await shippingService.get();
        return data?.AddressId || null;
    }

    async getBillingData() {
        // const { data, error, success } = await billingService.get();
        const { data, error, success, shippingAddressId } = await this.getData();
        let paymentId = data.PaymentId

        if (success) {
            this.shippingAddressId = shippingAddressId;

            this.updateUiOnly(() => {
                this.setupAddresses(data, this.shippingAddressId);
                this.setupMethods(data, false, paymentId);
            });

            this.updateSummary(data);

            this.addPaymentForm.setAddressId(this.selectedAddressValue);
        } else {
            this.$error.show().html(error);
        }

        this.addressesLoading = false;
        this.methodsLoading = false;
        this.loading = false;
    }

    async selectAddress() {
        this.$error.hide();

        const payload = {
            AddressId: this.selectedAddressValue
        };

        this.addPaymentForm.setAddressId(this.selectedAddressValue);
        let addresses = this.addresses;
        let billingParty = addresses.find((address) => address.AddressName === this.selectedAddressValue);
        //console.log('billp2', billingParty);
        store.mutations.SET_BILLING_PARTY(billingParty);
        //console.log('billingParty', billingParty);
      //  not needed anymore
      //  const { success, error } = await selectAddressService.post(payload);

      /*   if (success) {
            this.addPaymentForm.setAddressId(this.selectedAddressValue);
        } else if (error) {
            this.$error.show().html(error);
        } */
    }

    async addAddress(addressParty) {
        const payload = {
            AddressId: null,
            VcaAddressParty: addressParty
        };

        const { success, data, error } = await await selectAddressService.post(payload);

        if (success) {
            const {
                isValidated,
                response: validatedResponse
            } = await this.handleAddressValidation(data.UpsAddressValidationStatus, addressParty, data.SuggestedAddresses);

            if (isValidated) {
                this.updateUiOnly(() => {
                    this.setupAddresses(validatedResponse.data || data);
                });

                this.addPaymentForm.setAddressId(this.selectedAddressValue);

                this.addressFormVisible = false;
            }
        } else if (error) {
            this.checkoutForm.showError(error);
        }
    }

    async handleAddressValidation(status, originalAddress, suggestedAddresses = []) {
        const showPrompt = showSuggestions(status);

        if (!showPrompt) {
            if (status === statusCodes.UPS_UNAVAILABLE) logUpsServiceError();

            return {
                isValidated: true,
                response: {}
            }
        };

        return await this.showSuggestedAddresses(status, originalAddress, suggestedAddresses);
    }

    async showSuggestedAddresses(status, originalAddress, suggestedAddresses = []) {
        let response = {};

        const currentAddress = {
            address: originalAddress.Address1,
            address2: originalAddress.Address2,
            city: originalAddress.City,
            stateCode: originalAddress.StateCode,
            zip: originalAddress.ZipPostalCode
        };

        const suggestions = suggestedAddresses?.map((address, index) => ({
            addressId: `${index}`,
            address: address.Address1,
            address2: address.Address2,
            city: address.City,
            stateCode: address.StateCode,
            zip: address.ZipPostalCode
        }));

        const onSubmitHandler = async (isOriginal, value) => {
            let addressParty = originalAddress;

            if (!isOriginal) {
                const index = suggestions.findIndex(({ addressId }) => addressId === value);
                if (index > -1) {
                    addressParty = {
                        ...addressParty,
                        ...suggestedAddresses[index]
                    };
                }
            }

            response = await selectAddressService.post({
                AddressId: null,
                VcaAddressParty: addressParty,
                IsSuggestion: true
            });

            return response;
        };

        const addressValidation = new AddressValidation(
            status,
            currentAddress,
            suggestions,
            this.context,
            {},
            onSubmitHandler
        );

        const { isValidated } = await addressValidation.prompt();
        addressValidation.destroy();

        return {
            isValidated,
            response
        };
    }

    /* async postPaymentMethod() {
        if (!this.disableServiceUpdate) {
            this.loading = true;

            this.$error.hide();

            const payload = {
                AddressId: this.selectedAddressValue,
                PaymentId: this.selectedMethodValue
            }

            const { error, success } = await selectPaymentService.post(payload);

            if (!success) {
                this.$error.show().html(error);
            }

            this.loading = false;
        }
    } */

    async postReivewBillinginformation(reviewUrl) {
        //console.log('bp', store.getters.billingParty);
        //console.log('bp', store.state.billingParty);
        let addressValue = this.selectedAddressValue;
        let newbillingaddress = store.state.billingParty
        if(addressValue === '__checkoutBilling_newAddress__'){
            addressValue = '';
        }else {
            newbillingaddress = {}
        }
        const payload = {
            AddressId: addressValue,
            PaymentId: this.selectedMethodValue,
            VcaAddressParty: newbillingaddress
        }

        const { error, data, success } = await AddBillingAndPaymentMethodToCart.post(payload);

        //console.log(data);

        if (!success) {
            this.$error.show().html(error);
        }else {
            window.location.href = reviewUrl;
        }

    }

    setupAddresses(data, ShippingId) {
        const addresses = data.BillingAddresses;
        let IdValue = data.AddressId;
        if(data.AddressId === null) {
            IdValue = ShippingId
        }else {
            IdValue = data.AddressId
        }
        const billingParty = addresses.find((address) => address.AddressName === IdValue);
        //console.log('storing address in party', billingParty);
        this.shippingAddress = billingParty;
        store.mutations.SET_BILLING_PARTY(billingParty);
        let isPrimaryIndex = addresses.findIndex(address => address.IsPrimary == true );
        addresses.unshift(addresses.splice(isPrimaryIndex, 1)[0]);
      //  console.log('billingParty', billingParty);
        this.mapAddressOptions(addresses);

        this.setInitialAddress();
    }

    setupMethods(data, isAddedPayment, paymentId) {
        
        if(isAddedPayment){
            this.methodsFormVisible = false
        }

        const methods = data.SavedPayments;
        if (methods == null || Object.keys(methods).length === 0){
            //console.log('no cards', methods)
            this.$methodWrapper.hide();
            this.$methodCancelCtrl.hide();
            this.onAddMethodClick();
        }else{
            //console.log('data id', data.PaymentId);
            this.$methodWrapper.show();
            this.$methodCancelCtrl.show();
            let paymentMethod = methods.find((method) => method.Id === paymentId);
            let paymentMethodDefault = [];
            if(data.PaymentId === null) {
                paymentMethod = methods.find((method) => method.IsDefault === true);
            }
            //console.log('default payment method', paymentMethod);
            let isPrimaryIndex = methods.findIndex(methods => methods.IsDefault == true );
            methods.unshift(methods.splice(isPrimaryIndex, 1)[0]);

            store.mutations.SET_PAYMENT_METHOD(paymentMethod);
            this.mapPaymentMethods(methods);
    
            this.setInitialMethod();
        }
    }

    mapPaymentMethods(payments = []) {
        this.methods = payments;

        const methodOptions = this.methods.map(method => {
            const text = this.parseMethodText(method);
            return {
                text,
                value: method.Id
            };
        });

        this.methodOptions = methodOptions;
    }

    onAddAddressClick() {
        if (this.loading) return;

        this.addressFormVisible = true;

        this.newAddress = {};
        this.checkoutForm.setValues({
            firstName: '',
            lastName: '',
            address: '',
            address2: '',
            city: '',
            state: '',
            zip: ''
        });

        const options = [...this.addressOptions];
        const newAddressOption = { text: this.context.NewAddress, value: NEW_ADDRESS_OPTION_VALUE };
        const newAddressIndex = options.findIndex(({ value }) => value === NEW_ADDRESS_OPTION_VALUE);

        if (newAddressIndex > -1) {
            options[newAddressIndex] = newAddressOption;
        } else {
            options.push(newAddressOption);
        }

        this.addressOptions = options;

        this.updateUiOnly(() => {
            this.addressSelector.setValue(NEW_ADDRESS_OPTION_VALUE);
        });

        this.addressSelector.disableElement();
    }

    onAddressFormCancel() {
        this.updateUiOnly(() => {
            this.addressOptions = this.addressOptions.filter(({ value }) => value !== NEW_ADDRESS_OPTION_VALUE);
            this.addressSelector.setValue(this.prevAddressValue)
            this.addressSelector.enable();
            this.addressSelector.enableElement();
        });

        this.addressFormVisible = false;
    }

    onAddMethodClick() {
     //   if (this.loading) return;
        this.methodsFormVisible = true;
    }

    async onAddressUpdate(value) {
        this.prevAddressValue = this.selectedAddressValue;
        this.selectedAddressValue = value;

        if (!this.disableServiceUpdate) {
            this.loading = true;
            await this.selectAddress();
            this.loading = false;
        }
    }

    async onCheckoutFormUpdate(address) {
        if (!address) return;

        const addressPary = {
            ...address,
            IsPrimary: false,
            CountryCode: "US",
            Country: "United States",
            PhoneNumber: null
        };

        this.checkoutForm.hideError();

        this.checkoutForm.loading = true;

        await this.addAddress(addressPary);

        this.checkoutForm.loading = false;
    }

    onMethodUpdate(value) {
        this.selectedMethodValue = value;
        //console.log(this.shippingAddress);
      //  this.selectedAddressValue = this.shippingAddress.AddressName

        //this.postPaymentMethod();
    }

    onReviewClick(evt) {
        evt.preventDefault();
      /*   if (!this.loading && this.selectedMethodValue && this.selectedAddressInfo) {
            return;
        } */
        
        let reviewUrl = evt.currentTarget.getAttribute('href');

        if (!this.selectedMethodValue) {
            this.methodSelector.setInvalid();
            this.methodSelector.focus();
        } else if (!this.selectedAddressInfo) {
            this.$error.show().html(`Shipping address wasn't saved in the previous step. "Same as Shipping" can't be selected for your billing address.`);
        }else{
            this.postReivewBillinginformation(reviewUrl);
        }
    }



    parseAddressText(address) {
        let text = address.Address1;

        if (address.Address2) {
            text += ` ${address.Address2}`;
        }

        text += ` ${address.City}, ${address.StateCode} ${address.ZipPostalCode}`;

        return text;
    }

    parseMethodText(method) {
        const postfix = method.LastDigits;
        const text = `${method.CardName} ****${postfix}`;
        return text;
    }

    renderLabels() {
        this.$addLabel.html(this.context.AddNew);
        this.$addressLabel.html(this.context.BillingAddress);
        this.$methodLabel.html(this.context.PaymentMethod);
        this.$reviewLabel.html(this.context.ReviewOrder);

        if(this.context.PromotionNoteIcon && this.context.PromotionNote){
            let pnote = `<img src="${this.context.PromotionNoteIcon}" /><div>${this.context.PromotionNote}</div>`;
            this.$promotionsnote.html(pnote);
            this.$promotionsnote.addClass("mt-3");
        }else{
            this.$promotionsnote.hide();
        }
    }

    renderAddPaymentForm() {
        this.addPaymentForm = new CheckoutPaymentForm(this.$paymentFormPlaceholder, this.context, {
            classList: this.addPaymentFormClassList,
            onCancelBillHandler: () => this.methodsFormVisible = false,
            setupMethods: (data, isAddedPayment, paymentId) => this.setupMethods(data, isAddedPayment, paymentId),
            replaceOriginEl: true
        });

        this.addPaymentForm.render();
    }

    renderReviewLink() {
        if (this.$reviewCtrl.is('a')) {
            this.$reviewCtrl.attr('href', this.context.NextStepUrl);
        }
    }

    renderLoaders() {
        this.addressLoader = new AjaxLoader(this.$addressLoaderPlaceholder, {
            ...DEFAULT_LOADER_OPTIONS,
            srText: this.context.LoadingAddresses
        });

        this.methodLoader = new AjaxLoader(this.$methodLoaderPlaceholder, {
            ...DEFAULT_LOADER_OPTIONS,
            srText: this.context.LoadingMethods
        });

        this.loader = new AjaxLoader(this.$loaderPlaceholder, {
            aria: false,
            size: 'xs'
        });

        this.loader.render();
    }

    renderSelectors() {
        this.addressSelector = new SelectBox(this.$addressPlaceholder, {
            id: this.addressId
        });
        this.addressSelector.disable();
        this.addressSelector.render();

        this.methodSelector = new SelectBox(this.$methodPlaceholder, {
            id: this.methodId
        });
        this.methodSelector.disable();
        this.methodSelector.render();
    }

    setInitialAddress() {
        if (this.addressOptions.find(({ value }) => value === store.getters.billingPartyId)) {
            this.addressSelector.setValue(store.getters.billingPartyId);
            return;
        }

        if (this.addressOptions.length > 0) {
            this.addressSelector.setValue(this.addressOptions[0].value);
        } else {
          //  this.$edit.hide();
          //  this.onAddAddressClick();
        }
    }

    setInitialMethod() {

        //console.log('payment method getter',store.getters.paymentMethodId);
        if (this.methodOptions.find(({ value }) => value === store.getters.paymentMethodId)) {
            this.methodSelector.setValue(store.getters.paymentMethodId);
        }
    }

    setupAccessibleCollapse() {
        const addressFormId = `addressForm_${this.id}`;
        this.$addressForm.attr('id', addressFormId);
        this.$addAddressCtrl.attr({ 'aria-expanded': false, 'aria-controls': addressFormId });

        const methodFormId = `methodForm_${this.id}`;
        this.$methodForm.attr('id', methodFormId);
        this.$addMethodCtrl.attr({ 'aria-expanded': false, 'aria-controls': methodFormId });
    }

    setupAccessibleIds() {
        const addressLabelId = `${this.addressId}_label`;
        const methodLabelId = `${this.methodId}_label`;

        this.$address.attr({ 'for': this.addressId, 'id': addressLabelId });
        this.$method.attr({ 'for': this.methodId, 'id': methodLabelId });

        this.$controls.attr('aria-labelledby', addressLabelId);
    }

    setupAccessibility() {
        this.setupAccessibleIds();
        this.setupAccessibleCollapse();

        this.$el.attr('aria-live', 'polite');
    }

    mapAddressOptions(addresses = []) {
        this.addresses = addresses;
        let shippingAddressIDCheck = this.shippingAddressId
        if(this.$isSubscriptionsPage){
            shippingAddressIDCheck = 0;
        }

        const sameAsOption = { text: this.context.SameAsShipping, value: this.shippingAddressId };
        const addressOptions =
            addresses
                .filter((address) => address !== null && address !== undefined && address.AddressName !== shippingAddressIDCheck)
                .map((address, index) => {
                    const text = this.parseAddressText(address);
                    return {
                        text,
                        value: address.AddressName
                    };
                });

        if(this.$isSubscriptionsPage){
            this.addressOptions = [
                ...addressOptions
            ];
        }else{
            this.addressOptions = [
                sameAsOption,
                ...addressOptions
            ];
        }
    }

    setupListeners() {
        this.$addAddressCtrl.on('click', () => this.onAddAddressClick());
        this.$addMethodCtrl.on('click', () => this.onAddMethodClick());
        this.$methodCancelCtrl.on('click', () => this.methodsFormVisible = false);
        this.$reviewCtrl.on('click', (evt) => this.onReviewClick(evt));

        this.addressSelector.watchValue((value) => this.onAddressUpdate(value));
        this.methodSelector.watchValue((value) => this.onMethodUpdate(value));

       // this.checkoutForm.watchValue((value) => this.onCheckoutFormUpdate(value));
    }

    updateSummary(data) {
        store.mutations.SET_FREE_SHIPPING_TEXT(data.FreeShippingText);
        store.mutations.SET_PROMO_CODE(data.PromotionCode);

        store.actions.setFormattedCartSummary({
            miniCartTotal: data?.FormattedTotal?.FormattedMiniCartTotal,
            discount: data?.FormattedTotal?.FormattedDiscount,
            shippingTotal: data?.FormattedTotal?.FormattedShipping,
            subtotal: data?.FormattedTotal?.FormattedSubtotal,
            taxTotal: data?.FormattedTotal?.FormattedTax,
            total: data?.FormattedTotal?.FormattedGrandTotal
        });

        store.mutations.SET_LOADING(false);
        store.mutations.SET_LOADED(true);
    }

    updateUiOnly(callback) {
        if (!isFn(callback)) return;

        this.disableServiceUpdate = true;
        callback();
        this.disableServiceUpdate = false;
    }

    parseTemplate(templateStr = template) {
        const parsed = $.parseHTML(templateStr);
        return $(parsed);
    }

    static extendTemplate(templateStr) {
        class CheckoutBillingExtended extends this { };
        CheckoutBillingExtended.prototype.parseTemplate = CheckoutBilling.prototype.parseTemplate.bind(CheckoutBillingExtended, templateStr);
        return CheckoutBillingExtended;
    }

    
    setEvents() {
/* 
        this.$closeAddress.on('click', () => {

            let form = $('#addPaymentContainer .checkout-address-form');
            form.hide();

        }); */
    }

    render() {
        if(this.$originEl) {
            if(this.replaceOriginEl) {
                this.$originEl.replaceWith(this.$el);
            } else {
                this.$originEl.html(this.$el);
            }
        }

       // this.setupBlufin();

        return this.$el;
    }

    renderCheckoutForm() {
        const defaultSchema = { ...addressFormDefaults.schema }
        const schema = {
            cardHolderName:{
                ...defaultSchema.cardHolderName,
                label: this.context.CardHolderName,
                name: 'CardHolderName',
            },
            firstName: {
                ...defaultSchema.firstName,
                label: this.context.FirstName,
                name: 'FirstName'
            },
            lastName: {
                ...defaultSchema.lastName,
                label: this.context.LastName,
                name: 'LastName'
            },
            address: {
                ...defaultSchema.address,
                label: this.context.Address,
                name: 'Address1'
            },
            address2: {
                ...defaultSchema.address2,
                label: this.context.Address2,
                name: 'Address2'
            },
            city: {
                ...defaultSchema.city,
                label: this.context.City,
                name: 'City'
            },
            state: {
                ...defaultSchema.state,
                label: this.context.State,
                name: 'StateCode'
            },
            zip: {
                ...defaultSchema.zip,
                label: this.context.Zip,
                name: 'ZipPostalCode'
            }
        };

        const options = {
            onCancelHandler: () => this.onAddressFormCancel(),
            onCancelBillHandler: () => this.onAddressFormCancel(),
            replaceOriginEl: true,
            schema
        };

        const context = {
            cancel: this.context.Cancel,
            heading: this.context.AddBillingAddress,
            requiredToken: this.context.RequiredToken,
            submit: this.context.ApplyUpdates,
            validation: this.context.ValidationMessage
        };


        this.checkoutForm = new CheckoutAddressForm(this.$addressFormPlaceholder, options, context);
        this.checkoutForm.init();
        this.checkoutForm.render();
    }

    renderAcceptedCards() {
        const {
            AmexIcon: amex,
            DiscoverIcon: discover,
            MastercardIcon: mastercard,
            VisaIcon: visa
        } = this.context;

        if(!amex.Url && !discover.Url && !mastercard.Url && !visa.Url) {
            this.$ccList.hide();
            return;
        }

        const img = document.createElement('img');

        [
            [ this.$amex, amex ],
            [ this.$discover, discover ],
            [ this.$mastercard, mastercard ],
            [ this.$visa, visa ]
        ].forEach(([ $el, card ]) => {
            if(card.Url) {
                const icon = img.cloneNode(false);
                icon.alt = card.Alt;
                icon.src = card.Url;
                $el.html(icon);
            } else {
                $el.hide();
            }
        });
    }

    displayLegalDisclaimer() {
        let displayRxRequired = false;

        store.getters.lines.forEach(line => {
            if (line.rxRequired) displayRxRequired = true;
        });

        displayRxRequired ? this.$prescription.show() : this.$prescription.hide();;
    }


    setAddressId(addressId) {
        this.form.options.addressId = addressId;
    }

    /* setupBlufin() {
        this.form = new AddPayment({
            containerId: '#addPaymentContainer',
            paymentFrameContainerId: 'paymentFrameContainer',
            paymentLoaderId: '#paymentLoader',
            savePaymentId: '#savePayment',
            savePaymentErrorId: '#addPaymentFailure',
            settingsId: '#paymentSettings',
            //setupMethods: (data) => this.form.setupMethods(data),
            updateAutoshipCheckboxId: '#active-subscriptions',
            urlPath: apiUrl
        });
        console.log('form', this.form);
        window.form = this.form;
    } */

    setupCancel() {
        this.$cancel.on('click', () => this.onAddressFormCancel())
        if(this.onCancelBillHandler) {
         //   this.$cancel.on('click', () => this.onAddressFormCancel()),;
        } else {
            this.$cancel.hide();
        }
    }

    setupClassList() {
        this.$el.addClass(this.classList);
    }

    updateUiOnly(callback) {
        if (!isFn(callback)) return;

        this.disableServiceUpdate = true;
        callback();
        this.disableServiceUpdate = false;
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-checkout-billing');

    if(rootEls.length) {
        store.actions.getCart();
    }

    rootEls?.forEach((el) => {
        const $el = $(el);
        const renderingContext = parseRenderingContext(el);

        const billing = new CheckoutBilling($el, renderingContext);
        billing.init();

        const unwatchLoaded = store.watch('loaded', (...[,,loaded]) => {
            if(loaded) {
                billing.onCartLoaded();
                unwatchLoaded();
            }
        });
    });
});
